import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaHome, FaBook, FaPlus, FaUser, FaCompass, FaBell } from 'react-icons/fa';

function MobileHeader({ userData, userId, categories, navigate }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchExpanded, setShowSearchExpanded] = useState(false);
  const [showMobileAddDropdown, setShowMobileAddDropdown] = useState(false);
  
  const searchRef = useRef(null);
  const mobileAddDropdownRef = useRef(null);

  const closeAllDropdowns = () => {
    setShowMobileAddDropdown(false);
  };

  const toggleSearchExpanded = () => {
    setShowSearchExpanded(!showSearchExpanded);
    closeAllDropdowns();
    
    if (!showSearchExpanded) {

      setTimeout(() => {
        if (searchRef.current) {
          searchRef.current.focus();
        }
      }, 100);
    }
  };

  const toggleMobileAddDropdown = () => {
    // Toggle this dropdown
    setShowMobileAddDropdown(!showMobileAddDropdown);
  };

  const handleMobileCategoryClick = (categoryId, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation(); // Olay yayılmasını engelle
    }
    
    // Önce UI temizle
    closeAllDropdowns();
    setShowSearchExpanded(false);
    
    // Doğrudan yönlendirme
    navigate(`/category/${categoryId}`);
  };

  const navigateAndCloseDropdowns = (path) => {
    navigate(path);
    closeAllDropdowns();
    setShowSearchExpanded(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
  
    try {
      if (searchQuery.trim()) {
        navigate(`/search?query=${encodeURIComponent(searchQuery)}`);
        setShowSearchExpanded(false);
      } else {
        throw new Error("Arama yapılacak kelime girmelisiniz.");
      }
    } catch (error) {
      console.error('Arama hatası:', error.message);
    }
  };
  
  const handleClickOutside = (event) => {
    const isOutsideDropdown = (
      (!mobileAddDropdownRef.current || !mobileAddDropdownRef.current.contains(event.target)) &&
      (!searchRef.current || !searchRef.current.contains(event.target))
    );
    
    const isNotDropdownButton = (
      !event.target.closest('.mobile-footer .footer-button[data-action="add"]')
    );
    
    if (isOutsideDropdown && isNotDropdownButton) {
      closeAllDropdowns();
      
      // Only close search if not clicking on search-related elements
      if (!event.target.closest('.search-icon-container') && 
          !event.target.closest('.mobile-footer .footer-button[data-action="search"]')) {
        setShowSearchExpanded(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <header className={`header ${showSearchExpanded ? 'search-expanded' : ''}`}>
        <div className="header-left">
          <div className="logo">
            <Link to="/dashboard">
              <img src="/LİBROZİ BOŞ MOR.png" alt="KitapOku Logo" className="logo-image" />
            </Link>
          </div>
        </div>
        
        <div className="header-spacer"></div>
        
        {/* Mobile notification ve discover icon */}
        {!showSearchExpanded && (
          <div className="mobile-actions">
            <Link to="/discover" className="mobile-discover">
              <FaCompass />
            </Link>
            <Link to="/notifications" className="mobile-notification">
              <FaBell />
            </Link>
          </div>
        )}
      </header>
      
      {/* Mobile expanded search view */}
      {showSearchExpanded && (
        <div className="mobile-search-expanded">
          <form className="mobile-search-form" onSubmit={handleSearch}>
            <FaSearch className="mobile-search-icon" />
            <input
              type="search"
              placeholder="Kitap veya yazar ara..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              ref={searchRef}
              autoFocus
            />
          </form>
          <div className="mobile-categories">
            <h2>Kategoriler</h2>
            <div className="mobile-category-grid">
              {categories.map((category) => (
                <button
                  key={category.id}
                  className="mobile-category-button"
                  onClick={(e) => handleMobileCategoryClick(category.id, e)}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      
      {/* Mobile Add dropdown */}
      {showMobileAddDropdown && (
        <div className="mobile-add-dropdown" ref={mobileAddDropdownRef}>
          <button onClick={() => navigateAndCloseDropdowns('/new-story')}>
            Yeni bir hikaye oluştur
          </button>
          <button onClick={() => navigateAndCloseDropdowns('/my-stories')}>
            Hikayelerim
          </button>
        </div>
      )}
      
      {/* Mobile footer navigation */}
      <div className="mobile-footer">
        <button onClick={() => navigateAndCloseDropdowns('/dashboard')} className="footer-button">
          <FaHome />
          <span>Home</span>
        </button>
        <button onClick={() => navigateAndCloseDropdowns('/library')} className="footer-button">
          <FaBook />
          <span>Library</span>
        </button>
        <button 
          onClick={toggleMobileAddDropdown} 
          className="footer-button" 
          data-action="add"
        >
          <FaPlus />
          <span>Add</span>
        </button>
        <button 
          onClick={toggleSearchExpanded} 
          className="footer-button"
          data-action="search"
        >
          <FaSearch />
          <span>Search</span>
        </button>
        <button onClick={() => navigateAndCloseDropdowns(`/profile/${userId}`)} className="footer-button">
          <FaUser />
          <span>Profile</span>
        </button>
      </div>
    </>
  );
}

export default MobileHeader;
